(function () {
  var TERMS_TEXT = 'Você só receberá notificações para este produto.';

  function normalizeStoqTerms() {
    document.querySelectorAll('#form-Terms').forEach(function (element) {
      if ((element.textContent || '').trim() !== TERMS_TEXT) {
        element.textContent = TERMS_TEXT;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', normalizeStoqTerms);
  document.addEventListener('shopify:section:load', normalizeStoqTerms);
  window.addEventListener('stoq:loaded', normalizeStoqTerms);
  window.addEventListener('restockrocket:loaded', normalizeStoqTerms);

  // Observer com debounce: agrupa rajadas de mutações em uma única execução,
  // em vez de rodar querySelectorAll a cada mutação do DOM do site inteiro.
  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () {
      scheduled = false;
      normalizeStoqTerms();
    }, 200);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
